

















































































import {
  createComponent,
  inject,
  onMounted,
  computed,
  ref,
  onBeforeUnmount,
  SetupContext
} from "@vue/composition-api";

import RealTimeTransferKey from "@/components/real-time-transfer-key";
import { isNullOrEmpty } from "@/methods/validation";

export default createComponent({
  setup(props: {}, context: SetupContext) {
    const realTimeTransferStore = inject(RealTimeTransferKey);
    if (!realTimeTransferStore) {
      throw new Error(`${RealTimeTransferKey} is not provided`);
    }

    const notFound = ref("");

    const loadedFlag = ref<boolean>(false);
    const searchBankName = ref<string>("");
    const bankCodeBankingFacilitiesList = computed(
      () => realTimeTransferStore.bankCodeBankingFacilitiesList
    );

    const setSelectBankInfos = (e: any) => {
      realTimeTransferStore.setBankPage("OtherBankSelection");
      realTimeTransferStore.setSelectBankInfos(e);
    };

    const setSearchBankName = (e: any) => {
      realTimeTransferStore.setSearchBankName(e);
    };

    const search = async () => {
      loadedFlag.value = true;
      // 空白or255文字以上の場合は検索しない
      if (
        isNullOrEmpty(searchBankName.value) ||
        searchBankName.value.length >= 255
      ) {
        loadedFlag.value = false;
        return;
      }
      // 検索文字をstoreに保存
      setSearchBankName(searchBankName.value);
      // 検索開始
      await realTimeTransferStore.getBankCodeBankingFacilitiesList(
        searchBankName.value
      );
      // 検索結果がなかった場合メッセージ表示
      notFound.value = !bankCodeBankingFacilitiesList.value.length
        ? "お探しの金融機関は見つかりませんでした。"
        : "";
      loadedFlag.value = false;
    };

    onBeforeUnmount(() => {
      document.removeEventListener("keypress", search);
    });

    onMounted(async () => {
      loadedFlag.value = true;
      await realTimeTransferStore.clearSearchBranchName();
      await realTimeTransferStore.clearBankCodeBankingFacilitiesBranchList();
      document.addEventListener("keypress", search);
      loadedFlag.value = false;
    });

    return {
      loadedFlag,
      bankCodeBankingFacilitiesList,
      searchBankName,
      notFound,
      setSelectBankInfos,
      setSearchBankName,
      search
    };
  },
  components: {}
});
